var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoteSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 1C5.81057 1 1.33337 5.4772 1.33337 11C1.33337 16.5229 5.81057 21 11.3334 21C16.8562 21 21.3334 16.5229 21.3334 11C21.3334 5.4772 16.8562 1 11.3334 1ZM11.3334 9.5C10.505 9.5 9.83337 10.1716 9.83337 11C9.83337 11.8284 10.505 12.5 11.3334 12.5C12.1618 12.5 12.8334 11.8284 12.8334 11C12.8334 10.1716 12.1618 9.5 11.3334 9.5Z",
    fill: "#E19845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 8C21.1906 7.5726 21.0231 7.1569 20.8328 6.7548M19.2079 4.2537C18.8918 3.8863 18.5524 3.5404 18.192 3.2186M14.3334 1C14.7811 1.1443 15.2164 1.3176 15.637 1.5178",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 9.5C10.505 9.5 9.83337 10.1716 9.83337 11C9.83337 11.8284 10.505 12.5 11.3334 12.5C12.1618 12.5 12.8334 11.8284 12.8334 11M11.3334 9.5C12.1618 9.5 12.8334 10.1716 12.8334 11M11.3334 9.5V7M12.8334 11H17.3334",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 1C5.81057 1 1.33337 5.4772 1.33337 11C1.33337 16.5229 5.81057 21 11.3334 21C16.8562 21 21.3334 16.5229 21.3334 11",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteSummary);
export default __webpack_public_path__ + "static/media/remote-summary.dff9acabe1581299cd51bb20fad97b3c.svg";
export { ForwardRef as ReactComponent };